import { render, staticRenderFns } from "./UsersStats.vue?vue&type=template&id=1cc9277a&scoped=true&"
import script from "./UsersStats.vue?vue&type=script&lang=ts&"
export * from "./UsersStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9277a",
  null
  
)

export default component.exports